module.exports = __webpack_public_path__ + "img/user-group.19e5428e.png";